<template>
  <div v-if="item">
    <fields-list :item="item" :fields="fields" />
   <div class="save-panel">
          <button class="btn btn-sm btn-warning btn-icon" @click="updateItem">
               <span class="ti-save"></span>Сохранить
          </button>
    </div>
  </div>
</template>

<script>
import { cardUpdate, cardContent, pushLang } from "@/plugins/functions";

export default {
  data: () => ({
    cardLink: "navigations",
    cardSetLink: "navigations",
    item: null,
    fields: [
      {
        col:' col-12 col-md-12',
        key: "title",
        label: "Наименование",
        type: "field",
        textType: "text",
        isMultiLang:true
      },
      {
        col:' col-12 col-md-12',
        key: "code",
        label: "Код",
        type: "field",
        textType: "text",
      },
      {
          col:' col-12 col-md-12',
          key: "platform",
          label: "Платформа",
          type: "static_radio",
          items: [
              { id: 'web', title: "Веб-админ" },
              { id: 'app', title: "Приложение" },
              { id: 'business', title: "Бизнес приложение" },
          ],
      },
      {
        col:' col-12 col-md-12',
        key: "icon",
        label: "Иконка",
        type: "field",
        textType: "text",
      },
      {
        col:' col-12 col-md-12',
        key: "type",
        label: "Type",
        type: "field",
        textType: "text",
      },
      {
        col:' col-12 col-md-12',
        key: "alphaClr",
        label: "alphaClr",
        type: "field",
        textType: "text",
      },
      {
        col:' col-12 col-md-12',
        key: "value",
        label: "Value",
        type: "field",
        textType: "text",
      },
      {
        col:' col-12 col-md-12',
        key: "color",
        label: "Color",
        type: "field",
        textType: "text",
      },
      {
        col:' col-12 col-md-12',
        key: "component",
        label: "Component",
        type: "field",
        textType: "text",
      },
      {
        col:' col-12 col-md-12',
        key: "activeIcon",
        label: "activeIcons",
        type: "field",
        textType: "text",
      },
      {
        col:' col-12 col-md-12',
        key: "position",
        label: "Position",
        type: "field",
        textType: "number",
      },
      {
        col:' col-12 col-md-12',
        key: "blocks",
        label: "Блоки (Дилерское приложение)",
        type: "selects",
        modal: "block",
        selectKey: "code",
      },
         {
        col:' col-12 col-md-12',
        key: "roles",
        label: "Для ролей",
        type: "selects",
        modal: "role",
        selectKey: "title",
      },
    ],
  }),

  props: ["id"],
  async created() {
    // this.pushLang();
    this.item = await this.cardContent(this.cardLink, this.id);
  },
  methods: {
    cardUpdate: cardUpdate,
    cardContent: cardContent,
    pushLang: pushLang,
    async updateItem() {
      let item = await this.cardUpdate(this.cardSetLink, this.item, this.fields);
      // if (item){
      //   this.item = item;
      // }
    },
  },
};
</script>
<style>
</style>
